module.exports = __webpack_public_path__ + "fonts/Roboto-ThinItalic.7bcadd06.ttf";